var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000610352H6.75339V20H0V0.000610352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07416 6.27686C4.44616 7.15436 3.17282 7.38936 2.23816 6.80311C1.30216 6.21686 1.05016 5.02436 1.67682 4.14686C1.98082 3.72061 2.44082 3.43311 2.97682 3.33311C3.51016 3.23436 4.05549 3.33436 4.51016 3.62061C4.96483 3.90561 5.27282 4.33686 5.37949 4.84061C5.48616 5.34186 5.37816 5.85186 5.07416 6.27686ZM6.68749 4.59561C6.51149 3.76686 6.00216 3.05061 5.25282 2.58061C4.87682 2.34436 4.46082 2.18561 4.02882 2.10561C4.03149 2.08811 4.04349 2.07436 4.04349 2.05561V0.44436C4.04349 0.19936 3.74482 0.000610352 3.37682 0.000610352C3.00749 0.000610352 2.71016 0.19936 2.71016 0.44436V2.05561C2.71016 2.07436 2.72216 2.08811 2.72482 2.10686H2.71816C1.83282 2.27186 1.07016 2.74936 0.567492 3.45061C-0.465842 4.90186 -0.0498418 6.87311 1.49549 7.84186C1.87549 8.07936 2.28883 8.20686 2.71016 8.28561V19.3881C2.71016 19.7269 3.00749 20.0006 3.37682 20.0006C3.74482 20.0006 4.04349 19.7269 4.04349 19.3881V8.30061C4.88616 8.13936 5.66616 7.69311 6.18216 6.97311C6.68349 6.26936 6.86349 5.42561 6.68749 4.59561Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_247_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 8,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62305 0H13.3768V19.9994H6.62305V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_247_660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30217 13.7231C8.93017 12.8456 10.2035 12.6106 11.1382 13.1969C12.0742 13.7831 12.3262 14.9756 11.6995 15.8531C11.3955 16.2794 10.9355 16.5669 10.3995 16.6669C9.86617 16.7656 9.32084 16.6656 8.86617 16.3794C8.41151 16.0944 8.10351 15.6631 7.99684 15.1594C7.89017 14.6581 7.99817 14.1481 8.30217 13.7231ZM6.68884 15.4044C6.86484 16.2331 7.37417 16.9494 8.12351 17.4194C8.49951 17.6556 8.91551 17.8144 9.34751 17.8944C9.34484 17.9119 9.33284 17.9256 9.33284 17.9444V19.5556C9.33284 19.8006 9.63151 19.9994 9.99951 19.9994C10.3688 19.9994 10.6662 19.8006 10.6662 19.5556V17.9444C10.6662 17.9256 10.6555 17.9119 10.6515 17.8931H10.6582C11.5435 17.7281 12.3062 17.2506 12.8088 16.5494C13.8422 15.0981 13.4262 13.1269 11.8808 12.1581C11.5008 11.9206 11.0875 11.7931 10.6662 11.7144V0.61189C10.6662 0.27314 10.3688 -0.000610352 9.99951 -0.000610352C9.63151 -0.000610352 9.33284 0.27314 9.33284 0.61189V11.6994C8.49151 11.8606 7.71151 12.3069 7.19417 13.0269C6.69284 13.7306 6.51284 14.5744 6.68884 15.4044Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_247_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 7,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2454 0H20.0001V19.9995H13.2454V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_247_660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3205 10.2295C18.0178 10.6545 17.5565 10.9433 17.0205 11.0433C16.9151 11.0633 16.8111 11.0683 16.7058 11.072C16.6778 11.0683 16.6525 11.057 16.6231 11.057C16.5925 11.057 16.5671 11.0695 16.5365 11.0733C16.1658 11.0583 15.8031 10.9545 15.4871 10.7558C15.0325 10.4708 14.7258 10.0395 14.6191 9.53576C14.5138 9.03451 14.6218 8.52451 14.9245 8.09951H14.9258C15.2298 7.67326 15.6898 7.38576 16.2271 7.28576C16.3591 7.26076 16.4951 7.24826 16.6271 7.24826C17.0271 7.24826 17.4191 7.35826 17.7591 7.57326C18.2138 7.85826 18.5205 8.28951 18.6271 8.79201C18.7338 9.29326 18.6258 9.80451 18.3205 10.2295ZM19.9351 8.54826C19.7605 7.71951 19.2498 7.00451 18.5018 6.53451C18.1271 6.29826 17.7178 6.14076 17.2898 6.05951V0.612012C17.2898 0.273262 16.9911 -0.000488281 16.6231 -0.000488281C16.2538 -0.000488281 15.9565 0.273262 15.9565 0.612012V6.06201C15.0751 6.22826 14.3165 6.70451 13.8178 7.40326C13.3151 8.10576 13.1351 8.95076 13.3111 9.78076C13.4858 10.6095 13.9965 11.3245 14.7445 11.7958C15.1165 12.027 15.5298 12.157 15.9565 12.2383V19.3883C15.9565 19.727 16.2538 19.9995 16.6231 19.9995C16.9911 19.9995 17.2898 19.727 17.2898 19.3883V12.2658C18.1698 12.0995 18.9285 11.6233 19.4285 10.9258C19.9311 10.222 20.1111 9.37701 19.9351 8.54826Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.9ce5db62ac0db32412f75114411ed949.svg";
export { ForwardRef as ReactComponent };